type TranslateFn = (
  key: string,
  params?: Record<string, string | number>,
  defaultValue?: string,
) => string;

export function knowledgeCategoryLabel(
  category: string | null | undefined,
  t: TranslateFn,
): string {
  if (!category) return '';
  const fallback = category.replace(/_/g, ' ');
  return t(`knowledge.category.${category}`, {}, fallback);
}
